var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessoptimization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.692,
    height: 29.867,
    viewBox: "0 0 24.692 29.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-17.329)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.877,69.476H41.036l-.8-1.6a8.7,8.7,0,0,1-1.09-.29l-1.488.982-1.594-.921.107-1.783a8.9,8.9,0,0,1-.8-.8l-1.783.107-.92-1.6.982-1.488a8.732,8.732,0,0,1-.29-1.09l-1.6-.8V58.366l1.6-.8a8.757,8.757,0,0,1,.29-1.09l-.982-1.488.92-1.6,1.783.107a8.842,8.842,0,0,1,.8-.8l-.107-1.782L37.659,50l1.488.982a8.758,8.758,0,0,1,1.09-.29l.8-1.6h1.841l.8,1.6a8.718,8.718,0,0,1,1.09.29L46.254,50l1.6.921-.107,1.784a8.931,8.931,0,0,1,.8.8l1.783-.107.921,1.6-.982,1.488a8.731,8.731,0,0,1,.29,1.09l1.6.8v1.841l-1.6.8a8.764,8.764,0,0,1-.29,1.09l.982,1.488-.92,1.6-1.784-.107a8.869,8.869,0,0,1-.8.8l.107,1.783-1.6.921-1.489-.983a8.707,8.707,0,0,1-1.089.29Zm-1.241-.97h.642l.749-1.5.243-.041a7.752,7.752,0,0,0,1.394-.371l.231-.085,1.395.921.556-.321-.1-1.671.189-.157a7.915,7.915,0,0,0,1.021-1.02l.157-.189,1.67.1.321-.556-.921-1.395.086-.231a7.771,7.771,0,0,0,.372-1.394l.041-.242,1.5-.749v-.642l-1.5-.749-.041-.243a7.734,7.734,0,0,0-.372-1.394l-.085-.231.921-1.394L49.78,54.4l-1.67.1-.157-.189a7.941,7.941,0,0,0-1.02-1.02l-.189-.157.1-1.67-.556-.321-1.395.921-.231-.086a7.741,7.741,0,0,0-1.394-.372l-.243-.041-.748-1.5h-.642l-.749,1.5-.243.041a7.73,7.73,0,0,0-1.394.372l-.231.086-1.394-.92-.556.321.1,1.67-.189.157a7.915,7.915,0,0,0-1.02,1.02L35.8,54.5l-1.67-.1-.321.556.92,1.394-.085.23a7.786,7.786,0,0,0-.372,1.394l-.041.243-1.5.749v.642l1.5.749.041.243a7.715,7.715,0,0,0,.371,1.394l.085.231-.92,1.394.321.556,1.67-.1.157.189a7.9,7.9,0,0,0,1.02,1.02l.189.157-.1,1.67.556.321,1.395-.921.231.086a7.769,7.769,0,0,0,1.394.371l.243.041Z",
    transform: "translate(-29.611 -41.765)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.675,59.352A12.346,12.346,0,1,1,42.021,47.006,12.36,12.36,0,0,1,29.675,59.352Zm0-23.721A11.375,11.375,0,1,0,41.05,47.006,11.388,11.388,0,0,0,29.675,35.631Z",
    transform: "translate(-17.329 -29.485)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.389 6.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.97,
    height: 2.157,
    transform: "translate(1.526 1.144) rotate(45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.235,
    height: 0.97,
    transform: "translate(1.068) rotate(45)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.947 6.123)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.157,
    height: 0.97,
    transform: "translate(1.83 1.144) rotate(45)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.97,
    height: 3.235,
    transform: "translate(2.287) rotate(45)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.979)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.97,
    height: 3.666,
    transform: "translate(3.882 1.995)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5,3.99H72.752A2,2,0,0,1,71.341.584,1.984,1.984,0,0,1,72.752,0H77.5a1.995,1.995,0,0,1,1.411,3.405A1.981,1.981,0,0,1,77.5,3.99ZM72.752.971a1.024,1.024,0,0,0,0,2.049H77.5a1.024,1.024,0,1,0,0-2.049H72.752Z",
    transform: "translate(-70.757)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.351 15.527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.637,107.962a1.995,1.995,0,1,1,1.995-1.995A2,2,0,0,1,88.637,107.962Zm0-3.019a1.024,1.024,0,1,0,1.024,1.024A1.025,1.025,0,0,0,88.637,104.943Z",
    transform: "translate(-86.642 -103.973)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.428,
    height: 0.97,
    transform: "translate(3.504 1.509)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.445 10.62)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.97,
    height: 0.982,
    transform: "translate(6.415)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.971,
    height: 0.982,
    transform: "translate(9.93 0.682) rotate(30.026)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.971,
    height: 0.982,
    transform: "translate(12.636 3.03) rotate(59.974)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.97,
    transform: "translate(12.82 6.415)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.971,
    transform: "translate(12.27 9.439) rotate(30.034)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.971,
    transform: "translate(10.279 11.784) rotate(59.974)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.971,
    height: 0.982,
    transform: "translate(6.416 12.82)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.97,
    height: 0.982,
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 3.522, 11.784)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.971,
    height: 0.982,
    transform: "translate(1.533 9.441) rotate(59.974)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.97,
    transform: "translate(0 6.416)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.971,
    transform: "translate(1.168 3.031) rotate(30.026)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.982,
    height: 0.97,
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 3.871, 0.682)",
    fill: "#0080ff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessoptimization);
export default __webpack_public_path__ + "static/media/processoptimization.8adf68e4.svg";
export { ForwardRef as ReactComponent };